import { Button, Card, StatusMessage } from "@herefor/design-system";
import { INVITATION_LIFECYCLE_MESSAGES } from "@herefor/product-language";

export type InvitationLandingState = "ready" | "working" | "accepted" | "expired" | "private";

export interface InvitationLandingProps {
  readonly state: InvitationLandingState;
  readonly actionsDisabled?: boolean;
  readonly onAccept: () => Promise<void>;
}

export function InvitationLanding({
  state,
  actionsDisabled = false,
  onAccept,
}: InvitationLandingProps) {
  const copy = INVITATION_LIFECYCLE_MESSAGES.landing;
  if (state === "expired") {
    return (
      <section className="invitation-landing" data-invitation-state="expired">
        <h1>{copy.expiredTitle}</h1>
        <Card>
          <p>{copy.expiredBody}</p>
        </Card>
      </section>
    );
  }
  if (state === "private") {
    return (
      <section className="invitation-landing" data-invitation-state="private">
        <h1>{copy.privateTitle}</h1>
        <Card>
          <p>{copy.privateBody}</p>
        </Card>
      </section>
    );
  }

  return (
    <section className="invitation-landing" data-invitation-state={state}>
      <h1>{copy.heading}</h1>
      <Card>
        <p>{copy.explanation}</p>
        <Button
          disabled={actionsDisabled || state !== "ready"}
          onClick={() => {
            void onAccept();
          }}
        >
          {state === "working" ? copy.working : copy.action}
        </Button>
        {state === "accepted" ? (
          <StatusMessage tone="success">{copy.accepted}</StatusMessage>
        ) : null}
      </Card>
    </section>
  );
}
